export default __webpack_public_path__ + "static/media/illustration-payroll-component.21e1b77f.svg";